import React from "react";
import { Component } from "react";
import settingicon from "views/job-details/img/factorcards/setting.png";

import communication from "views/job-details/img/factorcards/communication.png";
import network from "views/job-details/img/factorcards/network.png";
import XMLID_2529_ from "views/job-details/img/factorcards/XMLID_2529_.png";
import document from "views/job-details/img/factorcards/document.png";
import art from "views/job-details/img/factorcards/art.png";
class IlearnSkillGain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
    };
  }
  render() {
    return (
      <div className="">
        {" "}
        <div className="mt-14">
          {" "}
          <div className="flex justify-between items-center  mb-8">
            <h2 className="fsize28 font-bold uppercase">
              SKILLS YOU WILL GAIN
            </h2>
          </div>
          <div className="grid grid-cols-6 gap-6">
            <card className="drop-shadow rounded-12px bgE77820 text-center  p-20px">
              <img src={settingicon} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-white">
                Service Orientation
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={communication} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Passion to meet customers
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={network} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Work with cross functional teams
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={XMLID_2529_} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Analytical mindset
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={document} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Analyse financial statements
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={art} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Quick learner
              </p>
            </card>
          </div>
        </div>
      </div>
    );
  }
}
export default IlearnSkillGain;
